// Catalog constants shared by the client and the Worker.

/**
 * System colour palettes. `teal` (P21 Cloud) and `clay` (AXIM Commerce) are the
 * exact values from the design spec; the others are for systems added later.
 */
export const PALETTES = {
  teal: { tile: '#0E6E6A', chipBg: '#DCEDEA', chipText: '#0B5451', flowBg: '#F1F8F6', flowBorder: '#CFE6E2' },
  clay: { tile: '#B24A1C', chipBg: '#F9E4D7', chipText: '#8E3712', flowBg: '#FCF5F0', flowBorder: '#F1DDCF' },
  indigo: { tile: '#3B4F9A', chipBg: '#E1E6F6', chipText: '#2E3E7C', flowBg: '#F3F5FB', flowBorder: '#D8DEF1' },
  plum: { tile: '#7A3E77', chipBg: '#F1E1F0', chipText: '#5F2E5C', flowBg: '#FAF3F9', flowBorder: '#EBD6E9' },
  olive: { tile: '#5C6B1E', chipBg: '#E9EDD6', chipText: '#46521A', flowBg: '#F6F8EE', flowBorder: '#DFE5C6' },
  slate: { tile: '#44505E', chipBg: '#E3E7EC', chipText: '#333D48', flowBg: '#F4F6F8', flowBorder: '#DCE1E7' },
}

export const PALETTE_KEYS = Object.keys(PALETTES)

/** Tile colours for a system with no skill yet (spec: NetSuite). */
export const NO_SKILL_TILE = { tile: '#DCD8CF', letter: '#4A4F57' }
export const NO_SKILL_TILE_PICKER = { tile: '#E4E0D7', letter: '#5E626A' }

export function paletteFor(key) {
  return PALETTES[key] ?? PALETTES.slate
}

export const CATEGORY_LABELS = {
  erp: 'ERP',
  ecommerce: 'eCommerce',
  pim: 'PIM',
  crm: 'CRM',
  wms: 'WMS',
  other: 'Other',
}

export const CATEGORY_KEYS = Object.keys(CATEGORY_LABELS)

/** Derived, never stored: published → ready, draft only → draft, nothing → none. */
export const SYSTEM_STATUS = { ready: 'Ready', draft: 'Draft', none: null }

export const ANSWER_MODES = [
  { key: 'discovery', number: 1, label: 'Discovery & intake' },
  { key: 'lookup', number: 2, label: 'Knowledge lookup' },
  { key: 'profile', number: 3, label: 'Emit System Profile' },
]

export function modeLabel(key) {
  return ANSWER_MODES.find((m) => m.key === key)?.label ?? null
}

export const CONFIDENCE_LEVELS = ['proven', 'documented', 'confirm']

export const CONFIDENCE_LEGEND = {
  proven: 'Used in a DCKAP implementation',
  documented: 'Vendor or verified community docs, not yet used by DCKAP',
  confirm: "Gap or assumption — verify on the customer's tenant",
}

export const RULE_STATUSES = ['approved', 'open', 'implemented', 'rejected']

export const ROLES = ['admin', 'editor', 'member']

export function canEditSkills(user) {
  return user?.role === 'admin' || user?.role === 'editor'
}

export function isAdmin(user) {
  return user?.role === 'admin'
}

/** Library deep link to a file section. */
export function skillFileHref(slug, path, anchor) {
  const params = new URLSearchParams({ file: path })
  return `/library/${slug}?${params.toString()}${anchor ? `#${anchor}` : ''}`
}
